module.exports = "import React from 'react';\nimport TimePicker from 'material-ui/TimePicker';\n\nconst TimePickerInternational = () => (\n  <div>\n    <TimePicker\n      hintText=\"Custom Labels\"\n      okLabel=\"确定\"\n      cancelLabel=\"取消\"\n    />\n  </div>\n);\n\nexport default TimePickerInternational;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/TimePicker/ExampleInternational.js
 ** module id = 1085
 ** module chunks = 0
 **/